import React from 'react';
import { useFormikContext } from 'formik';
import ShippingDetails from './ShippingDetails';
import PaymentDetails from './PaymentDetails';
import useStyles from './styles';
import { FormSection } from '../../QueueIntegrationModal/panelKit';

export default function ReviewOrder() {
  const { values: formValues } = useFormikContext();
  const classes = useStyles();
  return (
    <FormSection title="Resumo da assinatura">
      <div className={classes.summary}>
        <ShippingDetails formValues={formValues} />
        <PaymentDetails formValues={formValues} />
      </div>
    </FormSection>
  );
}
